import React, { createContext, useContext, useEffect, useState } from 'react';
import api, {
  getStoredToken,
  setStoredToken,
  getStoredUser,
  setStoredUser,
  clearStoredAuth,
} from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Initialize from sessionStorage. Tokens scoped to the current tab limit
  // the blast radius of any XSS leak and avoid persistent credentials on
  // shared devices. The api helper handles legacy localStorage cleanup.
  const [user, setUser] = useState(() => getStoredUser());
  const [token, setToken] = useState(() => getStoredToken());
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    setStoredToken(data.token);
    setStoredUser(data.user);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearStoredAuth();
    setToken(null);
    setUser(null);
  };

  const refreshMe = async () => {
    if (!token) return null;
    try {
      const { data } = await api.get('/auth/me');
      setStoredUser(data);
      setUser(data);
      return data;
    } catch (e) {
      console.error('[Auth] refreshMe failed', e);
      logout();
      return null;
    }
  };

  useEffect(() => {
    if (token && !user) {
      setLoading(true);
      refreshMe().finally(() => setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, refreshMe, loading, role: user?.role }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
